import React from 'react';
import useLocalization from 'localization';
import useTheme from 'branding/theme';
const P = ({ centered = false, inverted = false, noDefaultMargin = false, size = 'regular', styles, children, strong = false, ...rest }) => {
    const { t } = useLocalization();
    const { typography } = useTheme();
    const mergedStyles = {
        ...typography.paragraph[size],
        ...(centered && typography.centered),
        ...(inverted && typography.inverted),
        ...(!noDefaultMargin && typography.defaultMarginBottom),
        ...(strong && typography.strong),
        ...styles
    };
    return (React.createElement("p", { ...rest, style: mergedStyles }, typeof children === 'string' ? t(String(children)) : children));
};
export default P;
//# sourceMappingURL=index.js.map